module.exports = __webpack_public_path__ + "static/media/Hero-Inflatables-2.5ad6c908.jpg";